var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.notifications),function(item){return _c('div',{key:item.id},[_c(_setup.NotificationCard,{attrs:{"notification":item,"loading":_setup.isItemDownloading(item)},on:{"mark-as-read":function($event){return _setup.markAsRead(item)},"open-resource":_setup.onFileDownload}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }